import { EventEmitter, Injectable } from '@angular/core';
import { PaginationInstance } from './pagination-instance';

@Injectable({ providedIn: 'root' })
export class PaginationService {
  change = new EventEmitter<string>();
  private instances: Record<string, PaginationInstance> = {};
  private readonly DEFAULT_ID = 'DEFAULT_PAGINATION_ID';

  defaultId(): string {
    return this.DEFAULT_ID;
  }

  register(instance: PaginationInstance): boolean {
    if (instance.id == null) {
      instance.id = this.DEFAULT_ID;
    }
    if (!this.instances[instance.id]) {
      this.instances[instance.id] = instance;
      return true;
    }
    return this.updateInstance(instance);
  }

  private updateInstance(instance: PaginationInstance): boolean {
    let changed = false;
    const existing = this.instances[instance.id!];
    if (instance.currentPage !== existing.currentPage) {
      existing.currentPage = instance.currentPage;
      changed = true;
    }
    if (instance.itemsPerPage !== existing.itemsPerPage) {
      existing.itemsPerPage = instance.itemsPerPage;
      changed = true;
    }
    if (instance.totalItems !== existing.totalItems) {
      existing.totalItems = instance.totalItems;
      changed = true;
    }
    return changed;
  }

  getCurrentPage(id: string): number {
    return this.instances[id]?.currentPage;
  }

  setCurrentPage(id: string, page: number): void {
    const instance = this.instances[id];
    if (!instance) {
      return;
    }
    const maxPage = Math.ceil(instance.totalItems! / instance.itemsPerPage);
    if (page <= maxPage && page >= 1) {
      instance.currentPage = page;
      this.change.emit(id);
    }
  }

  getInstance(id: string = this.DEFAULT_ID): PaginationInstance {
    if (this.instances[id]) {
      return { ...this.instances[id] };
    }
    return {} as PaginationInstance;
  }
}
